// actionTypes.js
export const SET_VALUE_USER = "SET_VALUE_USER";
export const SET_ACTIF_USER = "SET_ACTIF_USER";
export const SET_DATE_USER = "SET_DATE_USER";
export const SET_CURRENT_PAGE_USER = "SET_CURRENT_PAGE_USER";
export const SET_ORDER_USER = "SET_ORDER_USER";
export const SET_SORT_FIELD_USER = "SET_SORT_FIELD_USER";
export const SET_ROLE_USER = "SET_ROLE_USER";
